import { render, staticRenderFns } from "./Stam.vue?vue&type=template&id=496fb324&scoped=true&"
import script from "./Stam.vue?vue&type=script&lang=js&"
export * from "./Stam.vue?vue&type=script&lang=js&"
import style0 from "./Stam.vue?vue&type=style&index=0&id=496fb324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496fb324",
  null
  
)

export default component.exports